import React, { useState, useRef, useEffect } from 'react';

const Timer = ({
  scheduledDate,
  showTimer,
  setShowTimer,
  scheduledTask,
  disableAt,
  warmupTime = 10 * 60000, // 10 minutes in milliseconds
  enableJoin = null,
}) => {
  const Ref = useRef(null);

  const initialTimerState = '00d 00h 00m 00s';
  const [timer, setTimer] = useState(initialTimerState);

  useEffect(() => {
    resetTimer();
    return () => clearInterval(Ref.current);
  }, []);

  const resetTimer = () => {
    setTimer(initialTimerState);

    if (Ref.current) clearInterval(Ref.current);
    const id = setInterval(() => {
      startTimer();
    }, 1000);
    Ref.current = id;
  };

  const startTimer = () => {
    let {
      timeRemaining,
      days,
      hours,
      minutes,
      seconds,
      totalMiliSeconds,
    } = getTimeRemaining();

    if (timeRemaining <= disableAt) {
      return clearInterval(Ref.current);
    }

    setTimer(
      (days > 9 ? days : '0' + days) +
        'd ' +
        (hours > 9 ? hours : '0' + hours) +
        'h ' +
        (minutes > 9 ? minutes : '0' + minutes) +
        'm ' +
        (seconds > 9 ? seconds : '0' + seconds) +
        's '
    );

    if (totalMiliSeconds < disableAt) runOnce(totalMiliSeconds);
  };

  const runOnce = (() => {
    let executed = false;
    return (totalMiliSeconds) => {
      if (!executed) {
        scheduledTask(totalMiliSeconds);
        executed = true;
      }
    };
  })();

  const getTimeRemaining = () => {
    const timeRemaining = getDateTimeRemaining(scheduledDate);
    const shouldShowTimer = timeRemaining > disableAt;
    if (timeRemaining < warmupTime) {
      enableJoin && enableJoin();
    }

    if (showTimer !== shouldShowTimer) {
      setShowTimer(shouldShowTimer);
    }

    const seconds = Math.floor((timeRemaining / 1000) % 60);
    const minutes = Math.floor((timeRemaining / 1000 / 60) % 60);
    const hours = Math.floor((timeRemaining / 1000 / 60 / 60) % 24);
    const days = Math.floor(timeRemaining / 1000 / 60 / 60 / 24);
    const totalMiliSeconds = timeRemaining;

    return { timeRemaining, days, hours, minutes, seconds, totalMiliSeconds };
  };

  return timer !== initialTimerState && <p>Begins in {timer}</p>;
};

export const getDateTimeRemaining = (scheduledDate) => {
  return Date.parse(scheduledDate) - Date.parse(new Date());
};

export default Timer;
